const initialState = {
	users: "",
	status: "",
};

const userInformationReducer = (state = initialState, action) => {
	switch (action.type) {
		case "USER_INFORMATION":
			return {
				...state,
				users: action.payload,
				status: action.status,
			};
		default:
			return state;
	}
};

export default userInformationReducer;
